export const editBasicDetailsFormFields = [
  {
    type: 'number',
    name: 'pincode',
    label: 'Pin Code',
    placeholder: 'Enter Valid PIN Code',
    example: 'E.g. 522006',
    keyboardType: 'numeric',
    maxLength: 6,
    config: {
      required: true,
    },
  },
  {
    type: 'selectDropDownBottomSheet',
    name: 'employmentType',
    label: 'Employment Type',
    placeholder: 'Select Employment Type',
    example: 'E.g. Self Employed',
    pointerEvents: 'none',
    dropOptions: [
      {
        criteriaName: 'employmentType',
        fields: [
          {
            displayValue: 'Self-Employed',
            value: 'Self-Employed',
            key: 1,
          },
          {
            displayValue: 'Salaried',
            value: 'Salaried',
            key: 2,
          },
          {
            displayValue: 'Business Owner',
            value: 'Business Owner',
            key: 3,
          },
          {
            displayValue: 'Not Working',
            value: 'Not Working',
            key: 4,
          },
        ],
      },
    ],
    isSearchable: false,
    isEditable: false,
    config: {
      required: true,
    },
  },
  {
    type: 'toggle',
    name: 'modeOfIncome',
    label: 'Income Mode',
    fieldOptions: [
      {
        id: '1',
        key: 'Bank',
        optionId: 'Bank',
        optionValue: 'Bank Account',
        icon: 'BankIcon',
      },
      {
        id: '2',
        key: 'Cash',
        optionId: 'Cash',
        optionValue: 'Cash',
        icon: 'CurrencyIcon',
      },
    ],
    config: {
      required: true,
    },
  },
  {
    type: 'number',
    name: 'annualIncome',
    label: 'Monthly Income',
    placeholder: 'Enter Monthly Income',
    example: 'E.g. ₹15,000',
    maxLength: 10,
    keyboardType: 'numeric',
    isAmount: true,
    iconLeft: 'CurrencyIcon',
    config: {
      required: true,
    },
  },
]
